import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL } from "@/constants/legal";

/**
 * Shared layout for legal pages (Privacy, Cookie, Termini, Note Legali).
 * Provides consistent typography, navigation, and metadata.
 */
export default function LegalLayout({ overline, title, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid="legal-page-root"
      className="min-h-screen bg-[#F9F8F6] text-[#0B192C]"
    >
      {/* Top bar */}
      <header className="border-b border-[#E5E1DA] bg-[#F9F8F6]/90 backdrop-blur-sm">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="font-serif-display text-xl tracking-tight"
            data-testid="legal-brand"
          >
            Metodo<span className="text-[#E89B6C]">·</span>di<span className="text-[#E89B6C]">·</span>Mare
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#0B192C] hover:text-[#0E7C8F] transition-colors"
          >
            <ArrowLeft size={14} />
            Torna al sito
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="border-b border-[#E5E1DA] py-16 md:py-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <p className="overline">{overline}</p>
          <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight">
            {title}
          </h1>
          <p className="mt-6 text-sm uppercase tracking-[0.18em] text-[#3A4F6B]">
            Ultimo aggiornamento: {LEGAL.lastUpdated}
          </p>
        </div>
      </section>

      {/* Content */}
      <article className="max-w-[820px] mx-auto px-6 md:px-10 py-16 md:py-20 legal-content">
        {children}
      </article>

      {/* Footer */}
      <footer className="border-t border-[#E5E1DA] py-10">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.18em] text-[#3A4F6B]">
          <p>© 2026 {LEGAL.ownerName} · Tutti i diritti riservati</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[#0E7C8F]">Privacy</Link>
            <Link to="/cookie" className="hover:text-[#0E7C8F]">Cookie</Link>
            <Link to="/termini" className="hover:text-[#0E7C8F]">Termini</Link>
            <Link to="/note-legali" className="hover:text-[#0E7C8F]">Note Legali</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
